import { render, staticRenderFns } from "./CompraItemTags.vue?vue&type=template&id=4cfcef88"
import script from "./CompraItemTags.vue?vue&type=script&lang=js"
export * from "./CompraItemTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports